module.exports = __webpack_public_path__ + "static/media/online_courses_Su_I-Wen.75514d8a.jpg";